import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { IssueRow } from "./IssueDialog";
import { api } from "../lib/api";

/** Project-level Issues section — every field issue raised from the Install tab. */
export default function ProjectIssuesPanel({ projectId }) {
  const [issues, setIssues] = useState([]);
  const [showResolved, setShowResolved] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/issues", { params: { project_id: projectId } });
      setIssues(data || []);
    } catch { setIssues([]); }
    setLoading(false);
  };
  useEffect(() => { if (projectId) load(); /* eslint-disable-next-line */ }, [projectId]);

  const open = issues.filter((i) => i.status !== "resolved");
  const resolved = issues.filter((i) => i.status === "resolved");
  const shown = showResolved ? issues : open;

  return (
    <div className="bg-white border border-gray-200 rounded-lg" data-testid="project-issues-panel">
      <div className="px-4 py-3 border-b border-gray-200 flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 text-red-600" />
        <h3 className="text-sm font-semibold text-gray-900">Issues</h3>
        <span className="text-xs text-gray-500" data-testid="project-issues-count">
          {open.length} open{resolved.length ? ` · ${resolved.length} resolved` : ""}
        </span>
        {resolved.length > 0 && (
          <button
            type="button"
            onClick={() => setShowResolved((v) => !v)}
            className="ml-auto text-xs text-blue-700 hover:underline"
            data-testid="project-issues-toggle-resolved"
          >
            {showResolved ? "Hide resolved" : "Show resolved"}
          </button>
        )}
      </div>
      <div className="px-3 py-1">
        {loading ? (
          <div className="py-6 text-center text-sm text-gray-500">Loading…</div>
        ) : shown.length === 0 ? (
          <div className="py-6 text-center text-sm text-gray-500" data-testid="project-issues-empty">
            No open issues — installers raise these from the Install tab.
          </div>
        ) : shown.map((i) => (
          <IssueRow key={i.id} issue={i} onChanged={load} />
        ))}
      </div>
    </div>
  );
}
